import RichText from 'components/rich-text';
import CloseIcon from 'assets/icons/close-x.svg';
import { ScrollableContainer } from '../scrollable-container';
import styles from './reading-tools-panels.module.scss';
import type { PortableTextBlock } from '@portabletext/types';
import type { ViewerAction } from '../../types';

const NO_TRANSCRIPTION_MESSAGE = 'No transcription available.';
const NO_TRANSLATION_MESSAGE = 'No translation available.';

export function ReadingToolsPanels({
	showTranscription,
	showTranslation,
	transcription,
	translation,
	dispatch,
}: ReadingToolsPanelsProps) {
	return (
		<div className={styles.readingToolPanelsContainer}>
			{showTranscription && (
				<ReadingToolPanelDesktop
					title="Transcription"
					emptyMessage={NO_TRANSCRIPTION_MESSAGE}
					content={transcription}
					onClose={() => dispatch({ type: 'hide_transcription' })}
				/>
			)}
			{showTranslation && (
				<ReadingToolPanelDesktop
					title="Translation"
					emptyMessage={NO_TRANSLATION_MESSAGE}
					content={translation}
					onClose={() => dispatch({ type: 'hide_translation' })}
				/>
			)}
		</div>
	);
}

function ReadingToolPanelDesktop({
	title,
	content,
	emptyMessage,
	onClose,
}: ReadingToolPanelDesktopProps) {
	const handleKeyDown = (e: React.KeyboardEvent<SVGSVGElement>) => {
		if (e.key === 'Enter' || e.key === ' ') {
			onClose();
		}
	};

	return (
		<div className={styles.readingToolPanel}>
			<div className={styles.readingToolPanelHeader}>
				<h2 className={styles.panelTitle}>{title}</h2>
				<CloseIcon
					className={styles.panelCloseIcon}
					onClick={onClose}
					onKeyDown={handleKeyDown}
					role="button"
					tabIndex={0}
				/>
			</div>
			<ScrollableContainer>
				{content?.length ? (
					<RichText value={content} />
				) : (
					emptyMessage && (
						<p className={styles.panelEmptyMessage}>{emptyMessage}</p>
					)
				)}
			</ScrollableContainer>
		</div>
	);
}

interface ReadingToolsPanelsProps {
	showTranscription: boolean;
	showTranslation: boolean;
	transcription?: PortableTextBlock[];
	translation?: PortableTextBlock[];
	dispatch: React.Dispatch<ViewerAction>;
}

interface ReadingToolPanelDesktopProps {
	title: string;
	onClose: () => void;
	emptyMessage?: string;
	content?: PortableTextBlock[];
}
